<template>
  <div class="mt-20 px-20 sm-max:px-5 md-max:mx-8">
    <div
        class="py-10 border-dashed border-red border-[6px] md-max:px-3 md-max:py-4"
    >
      <h3
          v-html="bannerTitle"
          class="lg:text-4xl md:text-26 text-xl px-0 lg:px-12 font-bold text-center text-blue md-only:pt-4 md-max:leading-6"
      >

      </h3>
      <h4
          v-html="bannerSubTitle"
          class="bg-[#7bbd41] md-max:leading-5 lg:mx-4 md-only:text-lg sm-max:text-lg font-bold lg:text-3xl text-lg text-white lg:p-3 md-max:py-1 md-max:px-2 text-center mt-6"
      >


      </h4>
    </div>
  </div>
</template>

<script setup>
// import Swatches from "./Swatches.vue"

const props = defineProps({
  bannerTitle: {
    type: String,
    default: 'WE’RE HERE FOR YOU DURING THIS TIME: GET 50% OFF YOUR ORDER WHILE SUPPLIES LAST! (WE’LL EVEN PAY FOR THE SHIPPING!)'
  },
  bannerSubTitle: {
    type: String,
    default: 'Current status: In stock. Your order will ship today.'
  },
})


defineBuilderComponent({
    friendlyName: "BannerDiscount",
    canHaveChildren: true,
    inputs: [
        {
            name: "bannerTitle",
            type: "richText",
            defaultValue: "WE’RE HERE FOR YOU DURING THIS TIME: GET 50% OFF YOUR ORDER WHILE SUPPLIES LAST! (WE’LL EVEN PAY FOR THE SHIPPING!)"
        },
        {
            name: "bannerSubTitle",
            type: "richText",
            defaultValue: "Current status: In stock. Your order will ship today."
        }
    ]
});
</script>